
export function setMeta(meta, val) {
	meta.base = new URL(val, meta.origin);
}
export function base64(bytes) {
	const binString = Array.from(bytes, (byte) =>
		String.fromCodePoint(byte)
	).join("");

	return btoa(binString);
}
export function rewriteJsAttr(fn, attr, code, meta) {
	return fn(code, `(inline ${attr} on element)`, meta);
}
export function rewriteJsInline(fn, code, module, meta) {
	return fn(code, `(inline script element)`, meta, module);
}
export function rewriteCss(fn, code, meta) {
	return fn(code, meta);
}
export function rewriteHttpEquiv(fn, content, meta) {
	const contentArray = content.split("url=");
	if (contentArray[1])
		contentArray[1] = fn(contentArray[1].trim(), meta);
	return contentArray.join("url=");
}
export function getInjectCode(func, cookie, found_head) {
	return func(cookie, found_head);
}
export function log(val) { console.log("aaaaa", val) }
